"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var query_exports = {};
__export(query_exports, {
  NotificationQuery: () => NotificationQuery
});
module.exports = __toCommonJS(query_exports);
var import_communication_types = require("@hcengineering/communication-types");
var import_communication_sdk_types = require("@hcengineering/communication-sdk-types");
var import_communication_shared = require("@hcengineering/communication-shared");
var import_types = require("../types");
var import_result = require("../result");
var import_window = require("../window");
var import_utils = require("../utils");
class NotificationQuery {
  constructor(client, teronlake, id, params, options, callback, initialResult) {
    this.client = client;
    this.teronlake = teronlake;
    this.id = id;
    this.params = params;
    this.options = options;
    this.callback = callback;
    if (initialResult !== void 0) {
      this.result = initialResult;
      void this.notify();
    } else {
      this.result = this.initResult();
      void this.result.then(() => {
        void this.notify();
      });
    }
  }
  static {
    __name(this, "NotificationQuery");
  }
  result;
  nexLoadedPagesCount = 0;
  prevLoadedPagesCount = 0;
  async rawInitResult() {
    const limit = this.params.limit != null ? this.params.limit + 1 : void 0;
    const findParams = {
      ...this.params,
      order: this.params.order ?? import_types.defaultQueryParams.order,
      limit: this.params.strict === true ? this.params.limit : limit
    };
    const res = await this.find(findParams);
    const isComplete = this.params.limit == null || this.params.strict === true || res.length <= this.params.limit;
    if (!isComplete) res.pop();
    const result = new import_result.QueryResult(res, (it) => it.id);
    result.setTail(isComplete);
    result.setHead(isComplete);
    if (this.params.total === true) {
      result.setTotal(res.total);
    }
    return result;
  }
  async initResult() {
    try {
      return await this.rawInitResult();
    } catch (error) {
      console.error("Failed to initialize query:", error);
      return new import_result.QueryResult([], (it) => it.id);
    }
  }
  async onEvent(event) {
    switch (event.type) {
      case import_communication_sdk_types.NotificationEventType.CreateNotification: {
        await this.onCreateNotificationEvent(event);
        break;
      }
      case import_communication_sdk_types.NotificationEventType.RemoveNotifications: {
        await this.onRemoveNotificationsEvent(event);
        break;
      }
      case import_communication_sdk_types.NotificationEventType.UpdateNotification: {
        await this.onUpdateNotificationEvent(event);
        break;
      }
      case import_communication_sdk_types.NotificationEventType.RemoveNotificationContext:
        await this.onRemoveNotificationContextEvent(event);
        break;
    }
  }
  async onRequest(event) {
  }
  async unsubscribe() {
  }
  async requestLoadNextPage(notify = true) {
    if (this.params.strict === true) return { isDone: true };
    if (this.result instanceof Promise) this.result = await this.result;
    if (this.result.isTail()) return { isDone: true };
    const result = await this.loadPage(import_communication_types.SortingOrder.Ascending, this.result.getLast()?.created, notify);
    this.nexLoadedPagesCount++;
    return result;
  }
  async requestLoadPrevPage(notify = true) {
    if (this.params.strict === true) return { isDone: true };
    if (this.result instanceof Promise) this.result = await this.result;
    if (this.result.isHead()) return { isDone: true };
    const result = await this.loadPage(import_communication_types.SortingOrder.Descending, this.result.getFirst()?.created, notify);
    this.prevLoadedPagesCount++;
    return result;
  }
  async loadPage(order, created, notify = true) {
    if (created == null) return { isDone: false };
    if (this.params.limit == null) return { isDone: true };
    if (this.result instanceof Promise) this.result = await this.result;
    const limit = this.params.limit;
    const findParams = {
      ...this.params,
      total: false,
      created: order === import_communication_types.SortingOrder.Ascending ? { greater: created } : { less: created },
      limit: limit + 1,
      order
    };
    try {
      const res = await this.find(findParams);
      const isDone = res.length <= limit;
      if (!isDone) res.pop();
      if (order === import_communication_types.SortingOrder.Ascending) {
        this.result.append(res);
        this.result.setTail(isDone);
      } else {
        this.result.prepend(res);
        this.result.setHead(isDone);
      }
      if (notify) {
        await this.notify();
      }
      return { isDone };
    } catch (error) {
      console.error(`Failed to load ${order === import_communication_types.SortingOrder.Ascending ? "next" : "previous"} page:`, error);
    }
    return { isDone: false };
  }
  removeCallback() {
    this.callback = () => {
    };
  }
  setCallback(callback) {
    this.callback = callback;
    void this.notify();
  }
  copyResult() {
    return this.result instanceof Promise ? void 0 : this.result.copy();
  }
  async find(params) {
    delete params.strict;
    return await this.client.findNotifications(params, this.id);
  }
  async onCreateNotificationEvent(event) {
    if (event.notificationId == null) return;
    if (this.result instanceof Promise) this.result = await this.result;
    if (this.result.get(event.notificationId) != null) return;
    const notification = import_communication_shared.NotificationProcessor.create(event);
    const match = (0, import_utils.matchNotification)(notification, { ...this.params, created: void 0 });
    if (!match) return;
    const res = this.params.order === import_communication_types.SortingOrder.Ascending ? this.result.getResult() : this.result.getResult().reverse();
    const first = res[0];
    const last = res[res.length - 1];
    const inRange = first != null && last != null && notification.created.getTime() >= first.created.getTime() && notification.created.getTime() <= last.created.getTime();
    if (!this.result.isTail() && !inRange) {
      return;
    }
    if (this.params.total === true) {
      const total = this.result.getTotal();
      this.result.setTotal(total + 1);
    }
    if (inRange) {
      this.result.push(notification);
      this.result.sort(
        (a, b) => this.params.order === import_communication_types.SortingOrder.Ascending ? a.created.getTime() - b.created.getTime() : b.created.getTime() - a.created.getTime()
      );
    } else if (this.params.order === import_communication_types.SortingOrder.Ascending) {
      if (this.params.limit !== void 0 && this.result.length === this.params.limit && this.params.strict === true) {
        this.result.setTail(false);
      } else {
        this.result.push(notification);
      }
    } else {
      if (this.params.limit !== void 0 && this.result.length === this.params.limit && this.params.strict === true) {
        this.result.pop();
        this.result.setHead(false);
      }
      this.result.unshift(notification);
    }
    await this.notify();
  }
  async updateNotificationRead(result, updated) {
    const isAllowed = /* @__PURE__ */ __name((n) => {
      if (this.params.read == null) return true;
      return n.read === this.params.read;
    }, "isAllowed");
    const currentLength = result.length;
    for (const notification of updated) {
      if (isAllowed(notification)) {
        result.update(notification);
      } else {
        result.delete(notification.id);
      }
    }
    const newLength = result.length;
    const { limit } = this.params;
    if (limit != null && currentLength !== newLength && currentLength >= limit && newLength < limit) {
      await this.reinit(currentLength);
    } else {
      void this.notify();
    }
  }
  async onUpdateNotificationEvent(event) {
    if (this.result instanceof Promise) this.result = await this.result;
    const updatedCount = event.updated ?? 0;
    let totalUpdated = false;
    if (this.params.total === true && updatedCount > 0) {
      if (this.params.read != null && this.params.read === event.updates.read) {
        this.result.setTotal(this.result.getTotal() + updatedCount);
        totalUpdated = true;
      } else if (this.params.read != null && this.params.read !== event.updates.read) {
        this.result.setTotal(this.result.getTotal() - updatedCount);
        totalUpdated = true;
      }
    }
    const toUpdate = (event.query.id != null ? [this.result.get(event.query.id)].filter((it) => it != null) : this.result.getResult().filter((it) => (0, import_utils.matchNotification)(it, event.query))).filter((it) => it.read !== event.updates.read);
    if (toUpdate === void 0 || toUpdate.length === 0) {
      if (totalUpdated) {
        await this.notify();
      }
      return;
    }
    const updated = toUpdate.map((it) => ({ ...it, ...event.updates }));
    await this.updateNotificationRead(this.result, updated);
  }
  async onRemoveNotificationsEvent(event) {
    if (this.params.contextId !== void 0 && this.params.contextId !== event.contextId) return;
    if (this.result instanceof Promise) this.result = await this.result;
    if (this.params.total === true) {
      await this.refresh();
      return;
    }
    const currentLength = this.result.length;
    let isDeleted = false;
    for (const id of event.ids) {
      const deleted = this.result.delete(id);
      isDeleted = isDeleted || deleted !== void 0;
    }
    const newLength = this.result.length;
    const { limit } = this.params;
    if (limit != null && currentLength >= limit && newLength < limit) {
      void this.reinit(currentLength);
    } else if (isDeleted) {
      void this.notify();
    }
  }
  async onRemoveNotificationContextEvent(event) {
    if (this.params.contextId != null && this.params.contextId !== event.contextId) return;
    if (this.result instanceof Promise) this.result = await this.result;
    if (event.contextId === this.params.contextId) {
      if (this.result.length === 0) return;
      this.result.setTotal(-1);
      this.result.deleteAll();
      this.result.setHead(true);
      this.result.setTail(true);
      void this.notify();
    } else if (this.params.total === true) {
      await this.refresh();
    } else {
      const toRemove = this.result.getResult().filter((it) => it.contextId === event.contextId);
      if (toRemove.length === 0) return;
      const length = this.result.length;
      for (const notification of toRemove) {
        this.result.delete(notification.id);
      }
      const { limit } = this.params;
      if (limit != null && length >= limit && this.result.length < limit) {
        void this.reinit(this.result.length);
      } else {
        void this.notify();
      }
    }
  }
  async notify() {
    if (this.callback == null) return;
    if (this.result instanceof Promise) this.result = await this.result;
    const window = new import_window.WindowImpl(
      this.result.getResult(),
      this.result.getTotal(),
      this.result.isTail(),
      this.result.isHead(),
      this
    );
    this.callback(window);
  }
  async reinit(limit) {
    if (this.result instanceof Promise) this.result = await this.result;
    this.result = this.find({ ...this.params, limit: limit + 1 }).then((res) => {
      const isTail = res.length <= limit;
      const isHead = res.length <= limit;
      if (res.length > limit) {
        res.pop();
      }
      const result = new import_result.QueryResult(res, (it) => it.id);
      result.setHead(isHead);
      result.setTail(isTail);
      result.setTotal(res.total);
      return result;
    });
    void this.result.then((res) => {
      void this.notify();
      return res;
    });
  }
  async refresh() {
    const nextPagesCount = this.nexLoadedPagesCount;
    const prevPagesCount = this.prevLoadedPagesCount;
    this.result = new import_result.QueryResult([], (it) => it.id);
    this.nexLoadedPagesCount = 0;
    this.prevLoadedPagesCount = 0;
    this.result = await this.rawInitResult();
    for (let i = 0; i < nextPagesCount; i++) {
      const { isDone } = await this.requestLoadNextPage(false);
      if (!isDone) break;
    }
    for (let i = 0; i < prevPagesCount; i++) {
      const { isDone } = await this.requestLoadPrevPage(false);
      if (!isDone) break;
    }
    await this.notify();
  }
}
//# sourceMappingURL=query.js.map
